import { useSearchParams } from 'react-router-dom';

import { LoadingErrorHint } from '$components/loading-error-hint/loading-error-hint';
import { useAuditEventDetailQuery } from '$features/audit-events/audit-events.api';
import { AuditEventDetail } from '$features/audit-events/detail/audit-event-detail';

export function AuditEventDetailWrap() {
  const [searchParams] = useSearchParams();
  const { data } = useAuditEventDetailQuery(searchParams.get('id')!);

  return (
    <div>
      {!data && <LoadingErrorHint className="m-top-xl" />}
      {data && <AuditEventDetail event={data} />}
    </div>
  );
}
